var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyRewards(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 158.125C38 158.125 38 165 50 165H93V115H38V158.125ZM108 165H150C162.5 165 162.5 158.125 162.5 158.125V115H108V165ZM170 70H156.844C158.781 66.2188 160 62.0312 160 57.5C160 42.3438 147.656 30 132.5 30C119.5 30 111.094 36.6563 100.312 51.3438C89.5312 36.6563 81.125 30 68.125 30C52.9688 30 40.625 42.3438 40.625 57.5C40.625 62.0312 41.8125 66.2188 43.7812 70H30C24.4688 70 20 70 20 80V105C20 105 22.25 105 25 105H175C177.75 105 180 105 180 105V80C180 70 175.531 70 170 70ZM68.0938 70C61.1875 70 55.5938 64.4062 55.5938 57.5C55.5938 50.5938 61.1875 45 68.0938 45C74.3125 45 78.9062 46.0312 95 70H68.0938ZM132.5 70H105.594C121.656 46.0938 126.125 45 132.5 45C139.406 45 145 50.5938 145 57.5C145 64.4062 139.406 70 132.5 70Z",
    fill: "#5605AA"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyRewards);
export default __webpack_public_path__ + "static/media/empty-rewards.7bdd6fb7.svg";
export { ForwardRef as ReactComponent };